import Milestone from '@/components/Growth/Milestone';

const MilestonePage = () => <Milestone />;

export default MilestonePage;
